/**
 * Middleware to handle site shoppability restrictions.
 *
 * This middleware redirects users to the home page when attempting to access
 * specific routes (cart, checkout, my account, help sections) when the site
 * is not in a shoppable state.
 *
 * @returns {void|NavigationFailure} Redirects to home page if site is not shoppable
 *
 * @example
 * // Automatically redirects to home page for restricted routes when site is not shoppable
 * export default defineNuxtRouteMiddleware(async (to) => { ... })
 *
 * @note
 * - Checks site shoppability status before allowing access to critical routes
 * - Handles both exact route paths and routes with trailing slashes
 * - Prevents access to cart, checkout, my account, and help sections
 */
export default defineNuxtRouteMiddleware(async to => {
  const { isShoppable } = await useIsShoppable()
  const {
    cartUrl,
    checkoutUrl,
    myAccount,
    help,
    helpSection,
    helpContactUs,
    homePath,
    getCanonicalUrl,
  } = useRouteHelper()
  if (
    (to.path === cartUrl ||
      to.path === cartUrl + '/' ||
      to.path === checkoutUrl ||
      to.path === checkoutUrl + '/' ||
      to.path === myAccount ||
      to.path === myAccount + '/' ||
      to.path === help ||
      to.path === help + '/' ||
      to.path === helpContactUs ||
      to.path === helpContactUs + '/' ||
      to.path === helpSection('contact-us/contact-form') ||
      to.path === helpSection('contact-us/contact-form/')) &&
    !isShoppable.value
  ) {
    const path = getCanonicalUrl(homePath)
    return navigateTo(path)
  }
})
